import React from 'react';
import { Box, Typography } from '@mui/material';
import { LEADS_TEXT_MUTED } from './leadsUi.styles';

const textSx = {
  fontSize: '11px',
  lineHeight: '16px',
  color: LEADS_TEXT_MUTED,
};

/**
 * Quién hizo una acción del lead, como el historial de Espacios:
 * "email · Rol" (el email recorta con elipsis, el rol queda visible).
 *
 * @param {{ actor: { email: string, roleLabel: string }|null, prefix?: string,
 *   suffix?: string, sx?: object }} props
 *   `actor`: salida de `describeLeadActor`. Null → no renderiza.
 */
export default function LeadActorLine({ actor, prefix = '', suffix = '', sx }) {
  if (!actor) return null;
  const parts = [actor.roleLabel, suffix].filter(Boolean);
  return (
    <Box
      data-testid="lead-actor"
      sx={{ display: 'flex', alignItems: 'center', gap: 0.5, minWidth: 0, ...sx }}
    >
      {prefix ? <Typography sx={{ ...textSx, flexShrink: 0 }}>{prefix}</Typography> : null}
      {actor.email ? (
        <Typography
          title={actor.email}
          sx={{ ...textSx, minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
        >
          {actor.email}
        </Typography>
      ) : null}
      {parts.length ? (
        <Typography sx={{ ...textSx, flexShrink: 0, whiteSpace: 'nowrap' }}>
          {`${actor.email ? '· ' : ''}${parts.join(' · ')}`}
        </Typography>
      ) : null}
    </Box>
  );
}
